import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import Tabs from 'src/components/Tabs';
import { useStudentHasServiceType } from 'src/hooks/useStudentHasServiceType';
import { routes } from 'src/routes';

import {
  useSingleStudentDetailsQuery,
  useSingleStudentGoalsListQuery,
  useSingleStudentYearsFiltersQuery,
} from './singleStudentApi';
import StudentHeader from './student-header/StudentHeader';
import StudentAbout from './StudentAbout';
import { StudentActivities } from './StudentActivities';
import StudentContact from './StudentContact';
import { StudentDocuments } from './StudentDocuments';
import StudentGoals from './StudentGoals';
import StudentNotes from './StudentNotes';
import StudentSchedule from './StudentSchedule';
import { getStudentTabs } from './studentTabs';

const SingleStudent = () => {
  const { id } = useParams();
  const { data: student } = useSingleStudentDetailsQuery(id!);
  const { data: studentYears } = useSingleStudentYearsFiltersQuery(id!);
  const { data: goals } = useSingleStudentGoalsListQuery({
    page: 1,
    id: id!,
    showMastered: true,
    schoolYearId: studentYears?.[studentYears.length - 1]?.id ?? undefined,
  });

  const hasSeItService = useStudentHasServiceType(id!, 'SEIT');
  const isPara = student?.isPara === true;

  const goalsTitle = (): string => {
    return goals?.total ? `Goals (${goals?.total})` : 'Goals';
  };

  const tabs = getStudentTabs({ goalsTitle: goalsTitle(), isPara, hasSeItService });

  return (
    <div className="bg-neutral-white">
      <StudentHeader />
      <Tabs items={tabs} underline className="px-4 sm:px-10" />
      <div className="bg-neutral-950 px-4 py-6 sm:p-10">
        <Routes>
          <Route
            path={routes.singleStudent.schedule}
            element={
              <div className="-m-10 h-[calc(100vh-200px)]">
                <div className="relative h-full">
                  <StudentSchedule studentId={id!} />
                </div>
              </div>
            }
          />
          <Route
            path={routes.singleStudent.goals}
            element={
              isPara ? <Navigate to={routes.singleStudent.schedule} replace /> : <StudentGoals />
            }
          />
          <Route path={routes.singleStudent.about} element={<StudentAbout />} />
          <Route path={routes.singleStudent.contact} element={<StudentContact />} />
          <Route path={routes.singleStudent.notes} element={<StudentNotes />} />
          {hasSeItService && (
            <>
              <Route path={routes.singleStudent.activities} element={<StudentActivities />} />
              <Route path={routes.singleStudent.documents} element={<StudentDocuments />} />
            </>
          )}
          <Route index element={<Navigate to={routes.singleStudent.schedule} replace />} />
        </Routes>
      </div>
    </div>
  );
};

export default SingleStudent;
